// extracted by mini-css-extract-plugin
export default {"item":"ShipmentsEventListItem_item__2ylw8","error":"ShipmentsEventListItem_error__u1+u1"};